import { type ActionFromReducer, combineReducers } from '@reduxjs/toolkit';

import { authReducer } from './auth/reducer';
import { configReducer } from './config/reducer';
import { envReducer } from './env/reducer';
import { modalReducer } from './modal/reducer';
import { navReducer } from './nav/reducer';

const reducerMap = {
  config: configReducer,
  nav: navReducer,
  modal: modalReducer,
  env: envReducer,
  auth: authReducer,
};

export const rootReducer = combineReducers(reducerMap);

export type RootState = ReturnType<typeof rootReducer>;

export type RootActions = ActionFromReducer<typeof rootReducer>;
